module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel01_770_280_th-5f1e21d44cf0d53e99b501a423d6e8b6.jpg";